import { Component,EventEmitter, Output} from '@angular/core';
import {Query} from "./category/query";
import {CategoryDataService} from "./category/category-data.service";
import {Category} from "./category/category";


declare var UIkit:any;
declare var $:any;

@Component({
  selector: 'app-root',
  templateUrl: '../assets/html/main.html',
  //styleUrls: ['./app.sass'],

  providers: [CategoryDataService]
})
export class AppComponent {

  queries: Query[] =[];
  topCategory: Category;
  service:CategoryDataService;
  @Output() change = new EventEmitter();

  // constant for swipe action: left or right

  isMobile:Boolean =  window.screen.width<415;
  ua = navigator.userAgent.toLowerCase();
  isAndroid = this.ua.indexOf("android") > -1;

  isPad:Boolean = window.screen.width<1025;
  isPortrait: Boolean = window.innerHeight > window.innerWidth;

  showSplash: Boolean = false;


  resetView(){


  }

  dimBg(){
    $('.darken').css({opacity:1});
  }


  public handleUserNav(ev:object){
    console.log('***********************APP: USER Nav')
    //Nav to Support Options


  }


  closeQuery(){
    console.log('App.CloseQuery')
    //$(".topNav").css('height','1px')
    var q: Query = this.service.currentQuery;
    if(q.parent!=null) q.parent.show=true;

    q.choose=true;
    q.set=null;
    //this.change.emit({category:this.service.currentQuery.set,id:this.service.currentQuery.id})
    this.updateQueries(this.service.currentQuery.set,this.service.currentQuery.id)
    this.service.currentQuery = q.parent;


      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      //$('footer').hide()
    //window.setTimeout(this.showClsBut,800)

  }

  gotoMenu(){
    console.log('App.gotoMenu')
    var q: Query = this.service.currentQuery;

    while (q.parent!==null){
      var q: Query = this.service.currentQuery;
      if(q.parent!=null) q.parent.show=true;

      q.choose=true;
      q.set=null;
      this.updateQueries(this.service.currentQuery.set,this.service.currentQuery.id)
      this.service.currentQuery = q.parent;

    }

    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera




    //this.queries.push(new Query({id:0,name:"Start",choose:false,set:null,show:true}));
    //this.queries.push(new Query({id:1,name:"Now What?",parent:this.queries[0],show:false}));
    //this.queries.push(new Query({id:2,name:"How?",parent:this.queries[1],show:false}));
    //this.queries.push(new Query({id:3,name:"How?",parent:this.queries[2],show:false}));

    /*console.log(this.topCategory);

    q = this.queries[0];
    q.choose = true;
    q.set = null;
    q.show = true;
    this.updateQueries(this.service.currentQuery.set,0)

    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera*/
  }


  showClsBut(){
    $(".topNav").css('height','32px')
  }

  openingPage():Boolean{
    return (this.queries[0] && this.queries[0].choose)? true : false
  }

  scrollToElement(element:any) {
    console.log('scrollToElement')
    var el = document.getElementById(element);
    var yPos = el.getClientRects()[0].top;
    var yScroll = window.scrollY;
    var interval = setInterval(function() {
      yScroll -= 10;
      window.scroll(0, yScroll);
      if (el.getClientRects()[0].top >= 0) {
        clearInterval(interval);
      }
    }, 50);
  }

  handleUpdate(ev:any){

    console.log('APP: Handle Update');

    var i:number = parseInt(ev.id);
    this.updateQueries(ev.category, i);


  }

  updateQueries(c:Category,i:number){
      this.service.listReady=false;
      console.log('APP:Update Queries')
    if(i<=this.queries.length) {

      //Set the next query up if needed
      var qu:Query = this.queries[i]
      if(qu.set!=null) {
        console.log('updateQueries::Parent has been set')
        var q: Query = this.queries[i + 1]
        q.results = c.subcategories;
        q.show=true;
        q.choose = true;
        q.set = null;


      }else{
        console.log('updateQueries::Parent not set')
        var q: Query = this.queries[i + 1]
        q.results = [];
        q.choose = false;
        q.show=false;
        q.set = null;


      }
    }else{

    }
    window.setTimeout(function(){$(".closeBtn").show()},500)




  }



  getData(){
    console.log('Get Data');

    this.categoryservice.getData().subscribe(
      data => {

        this.categoryservice.categories = this.topCategory = data.categories;
        console.log('PARSE');


        this.queries.push(new Query({id:0,name:"Start",choose:true,set:null,show:true}));
        this.queries.push(new Query({id:1,name:"Now What?",parent:this.queries[0],show:true}));
        this.queries.push(new Query({id:2,name:"How?",parent:this.queries[1],show:true}));
        this.queries.push(new Query({id:3,name:"How?",parent:this.queries[2],show:true}));

        console.log(this.topCategory);
        this.queries[0].results = this.topCategory.subcategories;
        this.queries[1].results = this.topCategory.subcategories;
        this.queries[2].results = this.topCategory.subcategories;
        this.queries[3].results = this.topCategory.subcategories;


      },
      err => {
        console.log(err);

      }
    )


      /*this.service.getData2().subscribe(
          data => {

              this.service.pageData = data
              //console.log(this.service.pageData);



          },
          err => {
              console.log(err);

          }
      )*/

  }



  constructor(private categoryservice: CategoryDataService) {
    this.service=categoryservice;

    categoryservice.userNav.subscribe(x => this.handleUserNav(x));

    if(this.isMobile && this.showSplash) $('.darken').css({opacity:0});
    this.getData();

  }




  //


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts